"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasicInfo = getBasicInfo;
async function getBasicInfo(machineRepo) {
    return await machineRepo.getBasicInfo();
}
